import { render } from "./producer-create-import.vue?vue&type=template&id=f136fd62"
import script from "./producer-create-import.vue?vue&type=script&lang=js"
export * from "./producer-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__